import { render, staticRenderFns } from "./FormTerapiaRespiratoria.vue?vue&type=template&id=f81c8dc6"
import script from "./FormTerapiaRespiratoria.vue?vue&type=script&lang=js"
export * from "./FormTerapiaRespiratoria.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports